<script>
import PopupViewerMixins from './mixins/PopupViewerMixins'

export default {
  name: 'PopupViewer',
  mixins: [PopupViewerMixins],
  data () {
    return {
      maximized: false,
      isLoading: false
    }
  },
  created () {
    this.$nextTick(() => {
      this.show = true
    })
  },
  methods: {
    toggleMaximize () {
      this.maximized = !this.maximized
    },
    loading (option) {
      this.isLoading = option
    }
  }
}
</script>

<template>
  <transition name="popup-viewer">
    <div class="popup-viewer-mask" v-if="show" @click="handleClickOutside">
      <div class="popup-viewer-wrapper">
        <div class="popup-viewer-container" :class="{'popup-viewer-shake': isClickingOutside, 'popup-viewer-container-maximized': maximized}">
          <div class="popup-viewer-header">
            <i class="fa fa-desktop" style="margin-left: 5px"></i> {{title}}
            <div>
              <button class="btn popup-viewer-header-button" @click="toggleMaximize">
                <i :class="`fa fa-window-${maximized ? 'restore' : 'maximize'}`"></i>
              </button>
              <button class="btn popup-viewer-header-button font-bold" @click="$emit('close')">X</button>
            </div>
          </div>
          <div class="popup-viewer-body" v-show="isLoading">
            <div class="popup-viewer-loading-container">
              <div class="popup-viewer-loader"></div>
            </div>
          </div>
          <div class="popup-viewer-body" v-show="!isLoading">
            <slot>default body</slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
@import "assets/popup-viewer.css";

.popup-viewer-container {
  width: 70%;
  max-height: 95vh;
  /*overflow: auto;*/
  margin: 0 auto;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, .6);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  /* border: 1px solid #1883d7; */
  border-radius: 7px;
}

.popup-viewer-container-maximized {
  width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
}

.popup-viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dedede;
  user-select: none;
}

.popup-viewer-header-button {
  border-radius: 0 !important;
  background: inherit;
  color: rgba(88, 102, 110, .7);
}

.popup-viewer-header-button:hover {
  color: rgba(88, 102, 110, 1);
}

.popup-viewer-body {
  margin: 20px 0;
  overflow: auto;
  position: relative;
  max-height: 85vh;
}

.popup-viewer-loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  min-width: 400px;
}
.popup-viewer-loader {
  border: 1px solid #f3f3f3;
  border-top: 4px solid #95afc0;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(720deg); }
}

.popup-viewer-enter-active, .popup-viewer-leave-active {
  transition: all .3s ease;
}
.popup-viewer-enter, .popup-viewer-leave-to {
  transform: scale(.8);
  opacity: 0;
}
.popup-viewer-enter-to {
  opacity: 1;
  transform: scale(1.01);
}
</style>



// WEBPACK FOOTER //
// PopupViewer.vue?fa351e9c